var chunkToChildrenMap = {
	"1779": [
		8096
	],
	"2076": [
		8096
	],
	"8182": [
		8096
	]
};
__webpack_require__.f.preload = (chunkId) => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.G);
};